module.exports = __webpack_public_path__ + "img/61_2.42462fb7.jpg";